import React from "react";
import ReactDOM from "react-dom";
import {
  Row,
  Col,
  Checkbox,
  Button,
  Tooltip,
  Popconfirm,
  message,
  Skeleton,
} from "antd";
import LazyLoad from "react-lazyload";
import ImageGallery from "react-image-gallery";
import Modal from "react-modal";
import cls from "classnames";
import CopyToClipboard from "react-copy-to-clipboard";

import { EditOutlined, DeleteOutlined, LinkOutlined } from "@ant-design/icons";

import "./index.scss";

export default class ImageList extends React.PureComponent<any, any> {
  constructor(props: any) {
    super(props);
    // this.onDoubleClick = this.onDoubleClick.bind(this);
    this.onCheckboxGroupChange = this.onCheckboxGroupChange.bind(this);
    // this.onImageGallerySlide = this.onImageGallerySlide.bind(this);
    // this.onClipboardCopy = this.onClipboardCopy.bind(this);
    this.container = React.createRef();
  }

  container;

  state = {
    showModal: false,
    activeItem: null,
    galleryIndex: 0,
    itemImageWidth: 0,
    itemMarginWidth: 0,
  };

  componentDidMount() {
    // Modal.setAppElement("#root");
    const dom = ReactDOM.findDOMNode(this.container.current) as HTMLElement;
    console.log(getComputedStyle(dom, null).width);
    // console.log(dom.width);
    // 资源列表的总宽度
    const containerWidth = getComputedStyle(dom, null).width;
    // 每行的元素数量
    const cols = 8;
    // 每个元素的宽度，也可用作高度
    // -10滚动条宽度
    const itemWidth = (parseInt(containerWidth) - 10) / cols;
    // 元素的外边距，下边和右边
    const marginWidth = parseInt((itemWidth * 0.15).toFixed(0));
    // 元素内容(图片)的宽高
    // -2边框宽度
    const itemImgWidth = (itemWidth - marginWidth - 2).toFixed(0);
    this.setState({
      itemImageWidth: itemImgWidth,
      itemMarginWidth: marginWidth,
    });
    // console.log(itemImgWidth.toFixed(2));
  }

  static shouldComponentUpdate(nextProps, nextState) {
    console.log();
  }

  onMouseEnter(index, e) {
    e.preventDefault();
    this.setState({
      activeItem: index,
    });
  }

  onMouseLeave(index, e) {
    e.preventDefault();
    this.setState({
      activeItem: null,
    });
  }

  onDoubleClick(index, e) {
    e.preventDefault();
    e.stopPropagation();
    // console.log(e.currentTarget);
    this.setState({ showModal: true, galleryIndex: index });
    // const { galleryIndex } = this.state;
    // console.log(this.gallery);
    // console.log(
    //   this.gallery.slideToIndex
    //   // this.gallery.current.getCurrentIndex
    // );
    // this.gallery.current.slideToIndex(galleryIndex);
    // // this.gallery.slideToIndex(galleryIndex);
    // console.log("double click");
  }

  onCheckboxGroupChange(checkedIds) {
    // console.log(checkedIds);
    this.props.onCheckboxGroupChange(checkedIds);
  }

  onConfirmDel(node, index, e) {
    // console.log(node, index, e);
    e.preventDefault();
    e.stopPropagation();
    const { onRemoveResource, onRemoveResourceAsync } = this.props;
    onRemoveResourceAsync({ id: node.id }).then((res) => {
      if (res.data > 0) {
        onRemoveResource(index);
      } else {
        // todo 删除失败
        console.log("删除失败", res);
      }
    });
    // console.log("icon click");
  }

  onClipboardCopy(text, result) {
    // console.log(text, result);
    // if(result) {
    //
    // } else {}
    result
      ? message.success("图片地址复制成功!")
      : message.error("图片地址复制失败!");
  }

  // renderResourceName(name: string): any {
  //   const { searchKeyword } = this.props;
  //   console.log(name, searchKeyword);
  //   if (name.includes(searchKeyword)) {
  //     const splitedName = name.split(searchKeyword);
  //     splitedName.join(
  //       `<span style={{ color: "red" }}>${searchKeyword}</span>`
  //     );
  //     console.log(splitedName);
  //     return splitedName;
  //   }
  //   // splitedName.splice(0, 0, <span style={{ color: "red" }}>{keyword}</span>);
  //   // console.log(splitedName);
  //   return name;
  // }

  renderResourceName(name: string) {
    const { searchKeyword } = this.props;
    // console.log(name, searchKeyword);
    if (name.includes(searchKeyword)) {
      const reg = new RegExp(searchKeyword, "g");
      return name.replace(reg, `<span style=color:red>${searchKeyword}</span>`);
    }
    // splitedName.splice(0, 0, <span style={{ color: "red" }}>{keyword}</span>);
    // console.log(splitedName);
    return name;
  }

  // hanldeKeyword(keywords) {
  //   let wordMatchString = "";
  //   let words = [].concat(keywords);
  //   words.forEach((item) => {
  //     let transformString = item.replace(/[.[*?+^$|()/]|\]|\\/g, "\\$&");
  //     wordMatchString += `|(${transformString})`;
  //   });
  //   wordMatchString = wordMatchString.substring(1);
  //   // 用于再次高亮与关闭的关键字作为一个整体的匹配正则
  //   let wholePattern = new RegExp(`^${wordMatchString}$`, "i");
  //   // 用于第一次高亮的关键字匹配正则
  //   let pattern = new RegExp(wordMatchString, "i");
  //   return [pattern, wholePattern];
  // }

  // onImageGallerySlide(index) {
  //   this.setState({
  //     galleryIndex: index,
  //   });
  // }

  render() {
    const { data, checkedIds } = this.props;
    const { list } = data;
    // console.log(11111, this.props.resources);
    // const { list } = resources;
    const { activeItem, itemImageWidth, itemMarginWidth } = this.state;
    // console.log("px", itemImageWidth);
    const galleryImages = list.map((resource) => {
      return {
        original: `http://${resource.domain}/${resource.resourceUrl}`,
        thumbnail: `http://${resource.domain}/${resource.resourceUrl}`,
      };
    });
    return (
      <div ref={this.container} className="images-manager-container">
        <Checkbox.Group
          style={{ width: "100%" }}
          onChange={this.onCheckboxGroupChange}
          value={checkedIds}
        >
          {list.map((resource: any, i: any) => {
            const actionsClasses = cls("imageitem-actions", {
              "imageitem-actions-hover": i === activeItem,
            });
            const resourceSrc = `http://${resource.domain}/${resource.resourceUrl}`;
            return (
              <div
                key={i}
                className="imageitem-wrapper"
                style={{
                  marginRight: itemMarginWidth,
                  marginBottom: itemMarginWidth,
                }}
                onMouseEnter={this.onMouseEnter.bind(this, i)}
                onDoubleClick={this.onDoubleClick.bind(this, i)}
                onMouseLeave={this.onMouseLeave.bind(this, i)}
              >
                <Checkbox value={resource.id}>
                  <div className="imageitem-container">
                    <div
                      className="imageitem-content"
                      style={{
                        width: itemImageWidth + "px",
                        height: itemImageWidth + "px",
                      }}
                    >
                      <div
                        className={actionsClasses}
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                      >
                        <div className="actions-btn">
                          <Popconfirm
                            title="确认删除"
                            cancelText="取消"
                            okText="确认"
                            onConfirm={this.onConfirmDel.bind(
                              this,
                              resource,
                              i
                            )}
                          >
                            <DeleteOutlined key="setting" />
                          </Popconfirm>
                        </div>
                        {/* <div className="actions-btn">
                            <EditOutlined key="edit" />
                          </div> */}
                        <div className="actions-btn">
                          <CopyToClipboard
                            text={resourceSrc}
                            onCopy={this.onClipboardCopy.bind(
                              this
                              // resourceSrc
                            )}
                          >
                            <LinkOutlined key="ellipsis" />
                          </CopyToClipboard>
                        </div>
                      </div>
                      <div className="imageitem-cover">
                        <LazyLoad
                          // debounce={5000}
                          overflow={true}
                          throttle={500}
                          height={itemImageWidth}
                          placeholder={
                            <Skeleton.Image
                              style={{
                                width: itemImageWidth + "px",
                                height: itemImageWidth + "px",
                              }}
                            />
                          }
                        >
                          <img
                            alt=""
                            width={itemImageWidth}
                            height={itemImageWidth}
                            src={resourceSrc}
                          />
                        </LazyLoad>
                      </div>
                    </div>
                    <Tooltip placement="bottom" title={resource.resourceName}>
                      <div
                        className="imageitem-title"
                        style={{ width: itemImageWidth + "px" }}
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: this.renderResourceName(
                              resource.resourceName
                            ),
                          }}
                        >
                          {}
                        </span>
                      </div>
                    </Tooltip>
                  </div>
                </Checkbox>
              </div>
            );
          })}
        </Checkbox.Group>
        <Modal
          className="images-manager-gallery-container"
          overlayClassName="gallery-overlay"
          ariaHideApp={false}
          shouldCloseOnEsc
          shouldCloseOnOverlayClick
          onRequestClose={() => {
            this.setState({ showModal: false });
          }}
          isOpen={this.state.showModal}
        >
          <Button
            className="gallery-btn-close"
            type="primary"
            onClick={() => {
              this.setState({ showModal: false });
            }}
          >
            close
          </Button>
          <ImageGallery
            slideDuration={100}
            startIndex={this.state.galleryIndex}
            showIndex
            lazyLoad
            // thumbnailPosition="top"
            showFullscreenButton={false}
            showPlayButton={false}
            items={galleryImages}
            // onSlide={this.onImageGallerySlide}
          />
        </Modal>
      </div>
    );
  }
}
